.group {
    display: flex;
    align-items: center;
    /* overflow: hidden; */
}
.groupContent {
    width: 100%;
    overflow: hidden;
}
.groupContentColumn
{
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.groupContentMainColumn {
    overflow: hidden;
}
.groupIcon {
    width:44px;
    height:44px;
    margin-right:12px;
}